import type { PropsWithChildren } from "react";

import classNames from "classnames";

import styles from "./ComponentHeading.module.scss";

export type ComponentHeadingProps = {
  testId?: string;
  className?: string;
  HtmlElement?: "div" | "span" | "h1" | "h2";
};

export const ComponentHeading = ({
  children,
  testId,
  HtmlElement = "div",
  className,
}: PropsWithChildren<ComponentHeadingProps>) => {
  if (!children) return null;
  const classes = classNames(styles.heading, className);

  return (
    <HtmlElement className={classes} data-testid={testId}>
      {children}
    </HtmlElement>
  );
};
